import { useNavigate } from 'react-router-dom';
import styles from '../../ResetPasswordPage/reset-password.module.sass';
import Logo from '../../../components/ui/logo/Logo';
import { useTranslation } from 'react-i18next';

export default function ResetPasswordSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.resetPassForm}>
      <Logo />
      <div className={styles.resetPassInputContainer}>
        <h2 className={styles.resetPassHeader}>
          {t('additionalPages.passwordCreatedSuccessfully')}
        </h2>
        <p style={{ textAlign: 'center' }}>
          {t('additionalPages.youCanNowLoginWithNewPassword')}.
        </p>
        <button
          type="submit"
          className={styles.resetPassBtn}
          onClick={() => navigate('/login')}
        >
          {t('additionalPages.goToLoginPage')}
        </button>
      </div>
    </div>
  );
}
